import React from 'react';

// Small inline badge showing how many credits an action will consume.
// Usa el ícono de créditos oficial de la app (`token_icon.png`), consistente
// con el resto de las superficies (ej. el pill "Generar 🪙N" de Anuncio).

type Tone = 'default' | 'on-primary' | 'subtle';
type Size = 'sm' | 'md';

const SIZE_CLASSES: Record<Size, { wrapper: string; icon: string }> = {
  sm: {
    wrapper: 'px-1.5 py-0.5 text-[11px] gap-1 rounded-full',
    icon: 'w-3 h-3',
  },
  md: {
    wrapper: 'px-2 py-0.5 text-[12.5px] gap-1 rounded-full',
    icon: 'w-3.5 h-3.5',
  },
};

const TONE_CLASSES: Record<Tone, string> = {
  // For neutral/light surfaces — uses brand primary tint.
  default: 'bg-brand-primary/10 text-brand-primary',
  // Sobre un botón brand-primary saturado: pill BLANCO sólido con texto oscuro
  // (mismo look que el "Generar 🪙N") para que el ícono de token se lea bien.
  'on-primary': 'bg-white text-brand-black',
  // Quiet variant for inline body copy / disabled states.
  subtle: 'bg-black/[0.06] text-brand-black/70',
};

interface CreditBadgeProps {
  credits: number;
  size?: Size;
  tone?: Tone;
  className?: string;
  // Optional human-readable label like "Necesitás 5 créditos para generar".
  // Rendered as `title` so it surfaces on hover without taking layout space.
  title?: string;
}

export const CreditBadge: React.FC<CreditBadgeProps> = ({
  credits,
  size = 'md',
  tone = 'default',
  className = '',
  title,
}) => {
  const sz = SIZE_CLASSES[size];
  const tn = TONE_CLASSES[tone];
  return (
    <span
      title={title}
      className={`inline-flex items-center font-semibold tabular-nums ${sz.wrapper} ${tn} ${className}`}
    >
      <img
        src="/images/token_icon.png"
        alt=""
        aria-hidden="true"
        className={`${sz.icon} object-contain`}
      />
      {credits}
    </span>
  );
};

export default CreditBadge;
